define(
    'modules/popup-content-box',[
        'modules/overlay-box',
        'utils/local-storage',
        'settings'
    ],
    function (OverlayBox, localStorage, settings) {

        /**
         * @class PopupContentBox
         */
        var PopupContentBox = (function () {
            /**
             * Popup info box is extention of overlay box.
             *
             * @param {string} [templateUrl] Url to html content
             * @constructor
             */
            function PopupContentBox(templateUrl) {
                this.templateUrl = templateUrl;
                this.destroyList = $.Deferred();
            }

            PopupContentBox.prototype.show =  function () {
                this.ob = new OverlayBox(this.templateUrl, {});
            
                this.ob.setup(false, true);
                this.ob.load(this.bindNever(this));
                this.ob.show();

                var _this = this;
                this.ob.addDestroyCallback(function() {
                    _this.destroyList.resolve();
                });
            };

            PopupContentBox.prototype.hide =  function () {
                this.ob.destroy();
                this.destroyList.resolve();
            };

            /**
             * Bind never show this again listener to button
             * 
             * @method bindNever
             */
            PopupContentBox.prototype.bindNever = function (_this) {
                
                eventCallback = function (e) {
                    if ($(e.target).hasClass('popup-content-block__never')) {

                        localStorage.set('popup-content-block__never', true, false);

                        e.preventDefault();
                        _this.ob.destroy();
                    }
                };

                $('html').on('click', '.popup-content-block__never', eventCallback);

                _this.destroyList.done(function() {
                    $('html').off('click', '.popup-content-block__never', eventCallback);
                });
            };

            return PopupContentBox;
        })();

        return PopupContentBox;
    }
);
